export const PHOTO_IMPORT_ERROR = "Import failed. Please try again.";
export const MAX_IMPORT_IMAGES = 6;
// Decimal MB keeps the complete JSON below Vercel's request limit.
export const MAX_IMPORT_BYTES = 4_000_000;

export function compressImportImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reader.onabort = () => reject(new Error(PHOTO_IMPORT_ERROR));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error(PHOTO_IMPORT_ERROR));
      image.onload = () => {
        try {
          const width = image.naturalWidth || image.width;
          const height = image.naturalHeight || image.height;
          if (!width || !height) throw new Error(PHOTO_IMPORT_ERROR);
          const scale = Math.min(1, 2400 / Math.max(width, height));
          const canvas = document.createElement("canvas");
          canvas.width = Math.max(1, Math.round(width * scale));
          canvas.height = Math.max(1, Math.round(height * scale));
          const context = canvas.getContext("2d");
          if (!context) throw new Error(PHOTO_IMPORT_ERROR);
          context.fillStyle = "#fff";
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          const result = canvas.toDataURL("image/jpeg", 0.85);
          if (!result.startsWith("data:image/jpeg;base64,")) throw new Error(PHOTO_IMPORT_ERROR);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      };
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export function photoImportPayload(images) {
  const payload = { images_base64: images };
  if (new Blob([JSON.stringify(payload)]).size >= MAX_IMPORT_BYTES) {
    throw new Error(PHOTO_IMPORT_ERROR);
  }
  return payload;
}
